import { render } from "./RegisterCart.vue?vue&type=template&id=66cac668"
import script from "./RegisterCart.vue?vue&type=script&lang=js"
export * from "./RegisterCart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__